import { render, staticRenderFns } from "./PricesModal.vue?vue&type=template&id=02e401bf&"
import script from "./PricesModal.vue?vue&type=script&lang=js&"
export * from "./PricesModal.vue?vue&type=script&lang=js&"
import style0 from "./PricesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports